<template>
  <div class="app">
    <WThemeProvider>
      <RouterView />
    </WThemeProvider>
  </div>
</template>

<script>
  import { mapActions, mapState } from 'pinia';
  import { useAuthStore } from '@/store/auth';
  import { useConfsStore } from '@/store/confs';
  import '@/assets/styles/override.css';
  import { useThemeStore } from './store/theme';

  import WThemeProvider from './components/layout/WThemeProvider.vue';

  export default {
    components: {
      WThemeProvider,
    },
    async mounted() {
      if (!this.conf) {
        await this.doGetAllConfs();
      } else {
        this.doGetAllConfs();
      }
      if (this.isAuthenticated) {
        if (!this.profile) {
          await this.doGetProfile();
        } else {
          this.doGetProfile();
        }
      }
    },
    created() {
      this.resetTheme();
      this.applyTheme();
    },
    computed: {
      ...mapState(useAuthStore, ['isAuthenticated', 'profile']),
      ...mapState(useConfsStore, ['conf']),
    },
    methods: {
      ...mapActions(useAuthStore, ['doLogin', 'doGetProfile', 'setError']),
      ...mapActions(useConfsStore, ['doGetAllConfs']),
      ...mapActions(useThemeStore, ['applyTheme', 'resetTheme']),
    },
  };
</script>

<style lang="scss">
  @import '@/assets/styles/theme.css';
  @import '@/assets/styles/variables.scss';
  @import '@/assets/styles/main.scss';
  @import '@/assets/styles/overrides.scss';
  @import '@/assets/styles/svg.scss';
  @import '@/assets/styles/animations.scss';

  .app {
    position: relative;
  }
</style>
